import React from 'react';
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Div from "@jumbo/shared/Div";
import { getAPIData, getAPIDataParams } from '../../../utils/apiFunction';
import menus from "../../../layouts/shared/sidebars/Sidebar/menus";
import { adalApiFetch } from '../../../../adalConfig';
import useSwalWrapper from "@jumbo/vendors/sweetalert2/hooks";
import ControlledTextField from "../../../components/ControlledTextField";
import { ACCESS, ACCESS_SECTIONS } from '../../../utils/constants/access';
import { checkAccess } from '../../../utils/roleFunctions';
import SubmitButtonDisplayer from "../../../components/SubmitButtonDisplayer";
import { textfieldDateFormat } from "../../../utils/dateFunctions";
import StringSelect from "../../../components/StringSelect";
import { userInfo } from '../../../../adalConfig';
import RoleSelect from '../Controls/RoleSelect';
import AccountSelect from '../Controls/AccountSelect';
import SubAccountSelect from '../Controls/SubAccountSelect';

const AddAccountMap = (props) => {
    const uri = process.env.REACT_APP_BASE_URL;
    console.log(props.data)
    const [completed, setCompleted] = React.useState(props.completed);
    const [loading, setLoading] = React.useState(false);
    const [role, setRole] = React.useState(props.data ? props.data.role : null);
    const [account, setAccount] = React.useState(null);
    const [subAccount, setSubAccount] = React.useState(null);
    const id = props.data ? props.data.id : '0';
    const Swal = useSwalWrapper();
    const requiredEditAccess = { key: ACCESS_SECTIONS.PROCESSING, value: ACCESS.EDIT };

    console.log("Role", role);

    const validate = () => {
        var warningMessages = [];
        var errorMessages = [];

        if (!role) {
            errorMessages.push('Role is required');
        }

        const formatErrorMessage = (array) => {
            var errString = '';
            array.map((a) => {
                errString = errString + a + '<br/>';
            });
            return errString;
        }

        if (errorMessages.length > 0) {
            Swal.fire({
                html: formatErrorMessage(errorMessages),
                icon: 'error',
                title: 'Oops...',

            });
        } else if (warningMessages.length > 0) {
            Swal.fire({
                html: formatErrorMessage(warningMessages),
                icon: 'warning',
                title: 'Oops...',
                showCancelButton: true,
                confirmButtonText: 'Yes, Continue',
                cancelButtonText: 'No, I\'ll edit it',

            }).then(result => {
                if (result.value) {
                    submit();
                } else if (result.dismiss === Swal.DismissReason.cancel) {

                }
            });
        } else {
            submit();
        }
    }

    const submit = async () => {
        setLoading(true);
        setCompleted(true);

        console.log('Role', role);
        console.log('Account', account);
        console.log('SubAccount', subAccount);

        var data = {
            RoleId: role.id,
            AccountId: account? account.id : null,
            SubAccountId: subAccount? subAccount.id : null
        }
        console.log(data, id);

        var response = await adalApiFetch(fetch, uri + '/RoleAccounts/AddUpdate/' + id + '?' + new URLSearchParams({
            ...data
        }), {
            method: 'post',
        });
        var resp = await (response.json());

        setLoading(false);
        if (props.reload) {
            props.reload();
        }

    }
    return (
        <Box style={{ marginTop: '10px' }}
            component="form"
            sx={{
                '& .MuiTextField-root': { m: 1, width: '24ch' },
            }}
            noValidate
            autoComplete="off"
        >
            <Div>

                {/*<Typography variant={"h3"}>Confirm OTR Information</Typography>*/}
                <Grid container spacing={0} mb={1}>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <RoleSelect state={role} setState={setRole} disabled={completed} roleId={props.data?.roleId} />
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <AccountSelect state={account} setState={setAccount} disabled={completed} accountId={props.data?.accountId} />
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <SubAccountSelect state={subAccount} setState={setSubAccount} disabled={completed} subaccountId={props.data?.subaccountId} />
                    </Grid>
                </Grid>

                <SubmitButtonDisplayer completed={completed} loading={loading} allowed={checkAccess(props.access, requiredEditAccess)} submitFunc={validate} handleClose={props.handleClose} />

            </Div>
        </Box >
    );
};

export default AddAccountMap;
